const FIREBASE_EMAIL_ACTION_MODES = new Set([
  'resetPassword',
  'recoverEmail',
  'verifyEmail',
]);

const SERVER_SAFE_ACTION_PATHS = new Set([
  '/',
  '/index.html',
]);

function hasNonEmptyString(value) {
  return typeof value === 'string' && value.trim() !== '';
}

export function resolveFirebaseEmailActionRedirect({ path, query } = {}) {
  if (!SERVER_SAFE_ACTION_PATHS.has(path)) {
    return undefined;
  }

  if (!query || !FIREBASE_EMAIL_ACTION_MODES.has(query.mode)) {
    return undefined;
  }

  if (!hasNonEmptyString(query.oobCode)) {
    return undefined;
  }

  return {
    name: 'AuthAction',
    query,
    replace: true,
  };
}
